import { useEffect, useState } from "react";

const day = 86400e3;
const iso = (t: number) => new Date(t).toISOString().slice(0, 10);
export const PRESETS = [
  ["yesterday", "Kemarin"],
  ["7d", "7 Hari"],
  ["30d", "30 Hari"],
  ["1y", "1 Tahun"],
  ["custom", "Custom"],
] as const;

export function presetRange(p: string): { start: string; end: string } {
  const now = Date.now() + 7 * 3600e3; // WIB
  const today = iso(now);
  if (p === "yesterday") return { start: iso(now - day), end: today }; // kemarin 00:00 s/d hari ini 23:59 (selaras semantik vendor)
  if (p === "30d") return { start: iso(now - 29 * day), end: today };
  if (p === "1y") return { start: iso(now - 364 * day), end: today };
  return { start: iso(now - 6 * day), end: today }; // 7d default
}

/**
 * Preset mana yang SEBENARNYA sedang berlaku, dihitung dari rentang nyata.
 *
 * Sebelumnya sorotan disimpan sebagai state lokal ber-nilai awal "yesterday",
 * terlepas dari rentang yang diberikan induknya. Dashboard dan Analytics memakai
 * default 7 hari, jadi chip menyorot "Kemarin" sementara angkanya 7 hari — label
 * yang berbohong tentang data di sebelahnya. Halaman yang membaca rentang dari
 * URL (Artikel, Posting) punya penyakit yang sama dan belum ketahuan.
 *
 * Dengan menurunkannya dari prop, sorotan tidak mungkin lagi bertentangan dengan
 * data, dari mana pun rentang itu datang.
 */
export function cocokPreset(start: string, end: string): string {
  for (const [val] of PRESETS) {
    if (val === "custom") continue;
    const r = presetRange(val);
    if (r.start === start && r.end === end) return val;
  }
  return "custom";
}

export function DateRange({ start, end, onApply }: { start: string; end: string; onApply: (s: string, e: string) => void }) {
  // Satu-satunya alasan menyimpan state: pengguna menekan "Custom" pada rentang
  // yang kebetulan sama persis dengan sebuah preset — panel tanggal harus tetap
  // terbuka meski nilainya masih cocok dengan preset itu.
  const [customBuka, setCustomBuka] = useState(false);
  const [s, setS] = useState(start);
  const [e, setE] = useState(end);

  // Rentang bisa berubah dari luar (navigasi, parameter URL, halaman lain).
  useEffect(() => { setS(start); setE(end); }, [start, end]);

  const aktif = customBuka ? "custom" : cocokPreset(start, end);

  function pick(p: string) {
    if (p === "custom") { setCustomBuka(true); return; }
    setCustomBuka(false);
    const r = presetRange(p);
    setS(r.start); setE(r.end);
    onApply(r.start, r.end);
  }

  return (
    <div style={{ display: "flex", gap: "var(--space-5)", alignItems: "center", flexWrap: "wrap" }}>
      <div className="avio-segment">
        {PRESETS.map(([val, label]) => (
          <button key={val} className="avio-segment__item" aria-pressed={aktif === val} onClick={() => pick(val)}>{label}</button>
        ))}
      </div>
      {aktif === "custom" && (
        <>
          <input className="avio-input" type="date" value={s} max={e} onChange={(ev) => setS(ev.target.value)} />
          <input className="avio-input" type="date" value={e} min={s} onChange={(ev) => setE(ev.target.value)} />
          <button className="avio-btn" data-variant="secondary" data-size="sm" disabled={!s || !e || s > e}
            onClick={() => { setCustomBuka(false); onApply(s, e); }}>Terapkan</button>
        </>
      )}
    </div>
  );
}
